<template>
  <i-select v-model="select_value" v-bind="$props" v-on="$listeners">
    <i-option v-for="option in options" :key="option" :value="option">
      {{ option }} {{ $t('shared.unit.time.second.middle') }}
    </i-option>
  </i-select>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    data: () => ({
      options: [10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60]
    }),

    computed: {
      select_value: {
        set: function(e) {
          this.$emit('input', e);
        },
        get: function() {
          return this.value;
        }
      }
    }
  };
</script>
